import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ProfileData } from '../../../features/user-dashboard/models/profile-data.interface';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly http=inject(HttpClient);

  
   getProfileData():Observable<ProfileData>{
    return this.http.get<ProfileData>(environment.baseUrl+`profile/`)


   }
  profileData(data:FormData):Observable<any>{
    return this.http.patch(environment.baseUrl+`profile/`,data)
  }
}
